import Axios, { AxiosError } from "axios";
import { useQuery } from "react-query";
import { baseDataKeys } from "src/query-keys";
import { FleetConfig, LEZ, APIError, ResidentialEmissionMap, ResidentialTotalEmissionMap } from "src/types";

export type LEZMutationData = Omit<LEZ, "id">;
export type FleetConfigMutationData = FleetConfig;

export async function queryFn() {
  return await new Promise((resolve) => setTimeout(resolve, 1000)).then(async () => {
    const response = await Axios.get<ResidentialMapsResponse>(`/planning-api/residentialmaps`);
    return response.data;
  });
}

interface ResidentialMapsResponse {
  mapList: ResidentialEmissionMap[];
  totalMapList: ResidentialTotalEmissionMap[];
}

export function useResidentialMaps() {
  return useQuery<ResidentialMapsResponse, AxiosError<APIError[]>>(baseDataKeys.residentialMaps, () => queryFn());
}
